import { useEffect, useRef } from 'react'
import toast from 'react-hot-toast'
import { registerSW } from 'virtual:pwa-register'

/**
 * Registra el service worker en modo "prompt".
 * - onNeedRefresh: hay una versión nueva → mostramos un toast persistente
 *   con un botón "Recargar". No recarga solo (no interrumpe formularios abiertos).
 * - onOfflineReady: la app quedó lista para abrir sin conexión.
 *
 * No renderiza nada; los toasts salen por el <Toaster /> que ya está en App.jsx.
 */
export default function PWAUpdater() {
  const updateSWRef = useRef(null)

  useEffect(() => {
    updateSWRef.current = registerSW({
      onNeedRefresh() {
        toast(
          (t) => (
            <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span>A new version is available.</span>
              <button
                onClick={() => {
                  toast.dismiss(t.id)
                  // true = recarga la página al activar el SW nuevo
                  updateSWRef.current?.(true)
                }}
                style={{
                  border: 'none',
                  borderRadius: 8,
                  padding: '6px 12px',
                  background: '#8152ff',
                  color: '#fff',
                  fontFamily: 'DM Sans, sans-serif',
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                }}
              >
                Reload
              </button>
            </span>
          ),
          { id: 'pwa-update', duration: Infinity }
        )
      },
      onOfflineReady() {
        toast.success('App ready to work offline.', { duration: 3000 })
      },
    })
  }, [])

  return null
}
